<script>
import HrDepartment from "../HrDepartment.vue";
import SelectCdjProjectHeader from "../SelectCdjProjectHeader.vue";
export default {
  components: { HrDepartment, SelectCdjProjectHeader },
  name: "ProjectCollectionTemplateCategorySave",
  props: {
    aging_type: {
      type: Array,
      default: () => []
    },
    arrears_type: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    },
    payment_type: {
      type: Array,
      default: () => []
    },
  },
  data(){
    return{
      formData: {
        id: null,
        is_active: 1,
        status: 1,
      },
      // list: [],
      visible: false,
      disabled: false,
      // aging_type: [],
      // arrears_type: [],
      selectDepartmentRef: null,
      selectCdjProjectHeaderRef: null
    }
  },
  methods:{
    show(data) {
      if (data) {
        this.formData = data
      }else {
        this.formData = {
          id: null,
          is_active: 1
        }
      }

      this.$nextTick(() => {
        if (this.$refs.selectCdjProjectHeaderRef) {
          this.$refs.selectCdjProjectHeaderRef.setData('project_id', data ? data.department_id : '')
        }
      })
      this.visible = true
      this.disabled = false
      // this.getList()
      // this.getAgingType()
      // this.getArrearsType()
    },
    handleDialogClose() {
      this.visible = false
      this.formData = {
        id: null,
        is_active: 1
      }
      this.$emit('close')
    },
    getList(p) {
      if(p)this.page = p
      this.$myhttp.get('butler/ProjectCollectionTemplateCategory/getList', {}).then(resp => {
        let res = resp.data
        if(res.code == 1) {
          this.list = res.data.list
        }
      })
    },
    handleSubmit() {
      this.disabled = true
      this.$myhttp.post('butler/ProjectCollectionTemplate/save', this.formData).then(resp => {
        let res = resp.data
        this.disabled = false
        if(res.code == 1) {
          this.$message.success(res.msg)
          this.handleDialogClose()
        }else {
          this.$message.error(res.msg)
        }
      })
    },
    showSelectDepartment() {
      var that = this
      this.$refs.selectDepartmentRef.show()
    },
    handleNodeClick(data) {
      this.$set(this.formData, 'department_name', data.ancestor_name || data.department_name)
      this.$set(this.formData, 'department_id', data.id)
    },
    onHeader(data) {
      if (data.project_id) {
        this.formData.department_id = data.project_id
        this.formData.department_name = data.project_list.find(item => item.erp_pindex_id == data.project_id).house_name
      }else {
        this.formData.department_id = ''
        this.formData.department_name = ''
      }
    }
  }
}
</script>

<template>
  <el-dialog
    :visible.sync="visible"
    :title="formData.id ? '编辑模版内容' : '创建模版内容'"
    append-to-body
    destroy-on-close
    :close-on-click-modal="false"
    @close="handleDialogClose"
    :z-index="9999"
    width="60%"
  >
    <el-form ref="form" :model="formData" label-width="120px" size="mini" style="margin-right: 20px;">
      <el-row>
        <el-col :span="12">
          <el-form-item label="模版分类" required>
            <el-cascader
              v-model="formData.category_id"
              :options="list"
              :props="{
            label: 'name',
            value: 'id',
            children: 'children',
            checkStrictly: true,
            emitPath: false
          }"
              placeholder="请选模版分类"
              clearable
            >
              <template slot-scope="{ data }">
                <span>{{ data.name }}</span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="账龄类型" required>
            <el-select v-model="formData.aging_type" filterable placeholder="请选择账龄类型">
              <el-option
                v-for="item in aging_type"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
<!--        <el-col :span="12">-->
<!--          <el-form-item label="欠费类型" required>-->
<!--            <el-select v-model="formData.arrears_type" filterable placeholder="请选择欠费类型">-->
<!--              <el-option-->
<!--                v-for="item in arrears_type"-->
<!--                :key="item"-->
<!--                :label="item"-->
<!--                :value="item"-->
<!--              />-->
<!--            </el-select>-->
<!--          </el-form-item>-->
<!--        </el-col>-->
        <el-col :span="12">
          <el-form-item label="缴费周期" required>
            <el-select v-model="formData.payment_type" filterable placeholder="请选择缴费周期">
              <el-option
                v-for="item in payment_type"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="所属项目">
<!--            <div @click="showSelectDepartment" style="cursor: pointer;">-->
<!--              <el-input-->
<!--                v-model="formData.department_name"-->
<!--                size="mini"-->
<!--                placeholder="请选择所属部门"-->
<!--                readonly-->
<!--              ></el-input>-->
<!--            </div>-->
<!--            <HrDepartment ref="selectDepartmentRef" @handleNodeClick="handleNodeClick"/>-->
            <SelectCdjProjectHeader ref="selectCdjProjectHeaderRef" @onHeader="onHeader" :items="['type_id','region_id','project_id']"></SelectCdjProjectHeader>
          </el-form-item>
        </el-col>
        <el-col :span="15">
          <el-form-item label="模版名称" required>
            <el-input v-model="formData.name" placeholder="请填写模版名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item label="模版内容" required>
        <el-input type="textarea" v-model="formData.content" placeholder="模版内容"></el-input>
      </el-form-item>
      <el-form-item label="模版说明">
        <el-input type="textarea" v-model="formData.description" placeholder="模版说明"></el-input>
      </el-form-item>
      <el-form-item label="是否启用" required>
        <el-radio-group v-model="formData.status">
          <el-radio :label="0" size="large">隐藏</el-radio>
          <el-radio :label="1" size="large">显示</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button size="small" @click="handleDialogClose">取消</el-button>
      <el-button size="small" type="primary" @click="handleSubmit" :disabled="disabled">确定</el-button>
    </template>
  </el-dialog>
</template>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/projectCollectionTemplate/template/save.vue